
const Image = ({src, alt, status, width, height}) => {
  return (
    <img src={src} alt={alt} height={height} width={width} />
  )
}

export default Image
